import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { Dashboard } from '../screens/Dashboard'
import { useAppState } from '../app-state'
import type { NavId } from '../components'

function DashboardRoute() {
  const navigate = useNavigate()
  const { openNewTx, setRailSelected } = useAppState()
  return (
    <Dashboard
      onNavigate={(id: NavId) =>
        navigate({ to: id === 'dashboard' ? '/' : `/${id}` })
      }
      onAction={(id) => {
        if (id === 'new-tx') {
          openNewTx()
          void navigate({ to: '/transactions' })
        }
      }}
      onSelectAccount={(id) => {
        setRailSelected(id)
        void navigate({ to: '/transactions' })
      }}
    />
  )
}

export const Route = createFileRoute('/')({
  component: DashboardRoute,
})
